import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { DbAdminServices } from "../../scripts/ah.mb.dbadmin-services";
import { IModelInfo } from "../../entities/nu-model-info";
import { ClientNotifier } from "../../scripts/ah.mb.client-notifications";
import { MessageBox } from "uiv";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";
import { bootbox } from "../../infrastructure/bootbox-shim";
import { IState } from "../../infrastructure/state/state-types";
import { State } from "vuex-class";

@Component
export default class DirectoryNodeInfo extends Vue {

    @Prop()
    value: IModelInfo;

    @State("profile") profile: IState;

    private userNotifier = new ClientNotifier();

    private services = new DbAdminServices();

    // Todo: Move button handlers in here

    openModelClicked(value: IModelInfo) {
        this.$emit("openModelClicked", value);
    }

    upgradeModel(value: IModelInfo) {

        //this.isBusy = true;
        var notification = this.userNotifier.showNotification(`Upgrading ${value.name} database...`, true, true);

        this.services.performDbUpgrades(value.fullyQualifiedModelId, false)
            .then(response => {

                var title = `${value.name} Database Upgrade`;

                MessageBox.confirm({
                    title: title, content: `${response.response}, show more information?`
                })
                    .then(() => {
                        var moreInfo = JSON.stringify(response);
                        MessageBox.alert({ title: title, content: moreInfo, size: "lg", html: false }, () => { });

                    })
            })
            .finally(() => this.userNotifier.clear(notification));

             

        //var notification = this.userNotifier.showBusyNotification(`Upgrading ${value.name}`);
        //FetchWrapper.sendCommandAndHandle("/api/1.0/dbamin/performdbupgrades", {
        //    method: "post", body: JSON.stringify({ modelId: value.name })
        //})
        //    .then(response => this.userNotifier.showSimpleMessage(response.response))
        //    .then(() => this.userNotifier.clear(notification))

    }

    createScenarioClicked(value: IModelInfo) {

        bootbox.prompt({
            title: "Scenario Name", callback: newScenarioName => {


                var payload = {
                    modelId: value.name,
                    scenarioName: newScenarioName,
                    description: `Scenario of ${value.name}`, // Todo: Allow entry of description
                    changeSet: []

                }
                var body = JSON.stringify(payload);

                var notification = this.userNotifier.showBusyNotification("Creating scenario...");

                // console.log(body);
                FetchWrapper.sendCommandAndHandle("/api/1.0/command/createScenario", { method: "post", body: body })
                    .then(result => {
                        if (result.success) {
                            this.$emit("scenarioCreated", value, newScenarioName);
                        }
                    })
                    .then((response) => this.userNotifier.clear(notification));
            }
        });
    
    }

    modelPinnedClick(value: IModelInfo) {

        var payload = {
            modelId: "_DirectoryTree",
            nodePathAndName: `${value.path}\\${value.name}`,
            variableName: "IsPinned",
            value: !value.isPinned
        }
        var body = JSON.stringify(payload);

        FetchWrapper.sendCommandAndHandle("/api/1.0/command/setnodedatavalue", { method: "post", body: body })
            .then(result => {
                if (result.success) {
                    this.value.isPinned = payload.value;
                    this.$emit("modelPinnedClick", value, payload.value);
                }
            });
    }

    downloadModelValidationClicked(value: IModelInfo) {
        this.userNotifier.showSimpleMessage("Preparing download...")
        const url = `/api/1.0/modelvalidation/download?modelId=${value.fullyQualifiedModelId}`;
        location.href = url;

    }

    clearUndoRedoStack(value: IModelInfo) {
        FetchWrapper.sendCommandAndHandle("/api/1.0/command/clearundoredostack", {
            method: "post",
            body: JSON.stringify({ modelId: value.fullyQualifiedModelId })
        });

    }

    checkCapability(capability: string): boolean {
        if (this.profile && this.profile.capabilities)
            return this.profile.capabilities.checkCapability(capability)
        return false;
    }


}



// WEBPACK FOOTER //
// ./ClientApp/components/directory-node-info/directory-node-info.ts